var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgItems(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.44393 14.7601L6.65733 5.00449C6.65947 4.9059 6.66162 4.7867 6.68342 4.71536L3.90507 5.55154C3.25165 5.74819 2.85963 6.45452 3.05628 7.10793L5.869 16.4537C6.06565 17.1071 6.79137 17.5096 7.44478 17.3129L8.39336 17.0274C7.26454 16.849 6.41881 15.9115 6.44393 14.7601Z",
    fill: "#81909E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.91533 3.80771L15.6133 3.95384C16.2955 3.96866 16.8414 4.53909 16.8266 5.22125L16.6137 14.9788C16.6017 15.5283 16.2293 15.9894 15.7282 16.1403C15.6073 16.1767 15.4788 16.1949 15.3462 16.1921L8.64832 16.0459C7.96609 16.031 7.42014 15.4607 7.43499 14.7784L7.64784 5.02091C7.65983 4.47139 8.03219 4.01034 8.5333 3.85953C8.65424 3.82313 8.78268 3.80475 8.91533 3.80771Z",
    fill: "#81909E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItems);
export default __webpack_public_path__ + "static/media/items.fd4514624973cbf594f339788d8fec3a.svg";
export { ForwardRef as ReactComponent };